import {Module} from '@fantasmagames/slot/src/common/Module';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {NetworkBasicState} from '@fantasmagames/slot/src/modules/network/states/NetworkBasicState';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {IndividualSymbolReelsEvents} from '@fantasmagames/slot/src/modules/reels/individual/IndividualSymbolReelsEvents';

export class NetworkModule extends Module<null> {
	public static readonly BASIC_STATE: string = 'basic';

	protected setupViews(): void {
		this.onCurrentStateHandle(ReelsEvents.REELS_SPINNING_STARTED);
		this.onCurrentStateHandle(ReelsEvents.REELS_RESPIN_STARTED);
		this.onCurrentStateHandle(AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED);
		this.onCurrentStateHandle(AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED);
		this.onCurrentStateHandle(IndividualSymbolReelsEvents.SPINNING_STARTED);
		this.onCurrentStateHandle(IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_STARTED);
	}

	protected setupStates(): void {
		this.addState(new NetworkBasicState(this, NetworkModule.BASIC_STATE));
	}

	protected enterFirstState(): void {
		this.changeStateTo(NetworkModule.BASIC_STATE);
	}

	protected setupEvents(): void {
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/network/NetworkModule.ts